/** Dependencies **/
import {useState, useRef, useEffect} from 'react';

/** Redux **/
import { useSelector } from 'react-redux';

function DataVizTooltipPerfAvgPos( props ) 
{
  /** Get props **/
  const { x, activePoints } = props;

  /** Get state from redux store **/
  const instanceConfig = useSelector( state => state.config.value );  

  /** Get config values **/
  const grpDomains = instanceConfig.groups;

  /** Init state **/
  const [tooltipOffsetX, setTooltipOffsetX] = useState( 0 );

  /** Set ref **/
  const tooltipContainer = useRef( null );

  /** Set datas for tooltip **/
  let currentDatas = [];
  let compareDatas = [];
  activePoints.forEach( point => 
  {
    const datas = {
      value: point.y,
      color: point.style.data.fill,
      tickValue: point.tickValue,
      labelValue: grpDomains.filter( grp => grp.value === point.labelValue )[0].label
    };

    if( point.childName.indexOf( 'current' ) === 0 )
      currentDatas = [...currentDatas, datas];
    else
      compareDatas = [...compareDatas, datas];
  });

  /** Set variation array values **/
  let variationDatas = [];
  if( compareDatas.length > 0 )
    currentDatas.forEach( ( data, index ) => 
    { 
      if( data.value >= 0 )
        variationDatas = [...variationDatas, {
          value: compareDatas[index].value - data.value, 
          color: data.color,
          label: data.labelValue
        }];
    });

  /** Update x position for tooltip **/
  useEffect( () => 
  {
    if( tooltipContainer !== null )
    {
      const tooltipWidth = tooltipContainer.current.offsetWidth;
      if( x > 1350 / 2 )
        setTooltipOffsetX( - tooltipWidth - 10 );
      else
        setTooltipOffsetX( 10 );
    }
  }, []);

  return (
    <foreignObject x={x + tooltipOffsetX} y={40} width="500" height="200">
      <div className="tooltip grey position" ref={tooltipContainer} style={tooltipContainer.current === null ? {visibility: 'hidden'} : {}}>
        <div className="tooltip-container">
          {currentDatas.length > 0 ?
            <ul>
              <li>{currentDatas[0].tickValue}</li>
              {currentDatas.map( ( point, index ) => 
                <li key={index}>
                  <hr style={{backgroundColor: point.color}} />
                  <span className="label">{point.labelValue}</span>&nbsp;:&nbsp;{new Intl.NumberFormat( 'fr-FR' ).format( point.value )}
                </li>
              )}
            </ul>
            : false
          }
          {compareDatas.length > 0 ?
            <ul>
              <li>{compareDatas[0].tickValue}</li>
              {compareDatas.map( ( point, index ) => 
                <li key={index}>
                  <hr className="dash" style={{backgroundColor: point.color}} />
                  <span className="label">{point.labelValue}</span>&nbsp;:&nbsp;{new Intl.NumberFormat( 'fr-FR' ).format( point.value )}
                </li>
              )}
            </ul>
            : false
          }
          {variationDatas.length > 0 ?
            <ul>
              <li>VARIATION</li>
              {variationDatas.map( ( data, index ) => 
                <li key={index}>
                  <span className="label">{data.label}</span>
                  &nbsp;:&nbsp;
                  <span className={data.value >= 0 ? "arrow up" : "arrow down" }>&#8682;</span>
                  {new Intl.NumberFormat( 'fr-FR', { signDisplay: 'always' } ).format( data.value )}
                </li>
              )}
            </ul>
            : false
          }
        </div>
      </div>
    </foreignObject>
  );
};

export default DataVizTooltipPerfAvgPos;